module.exports = __webpack_public_path__ + "static/media/LS022B7DH03_SPEC_LD2023X09_20231017.244726b8.pdf";